// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","black":"#000000","white":"#ffffff","grey":"#707070","light-grey":"#d4d4d4","medium-grey":"#9f9f9f","normal":".3s","input":"Z7Dw2Rrjeksdu8l8zbgyi","inputField":"_3k9vh_lHqQ3-bxIQXNgvy8","multi":"_1hLv2wVvraF067GimFYBzZ","isSelected":"fIlWm4E31v0_tJkSAAgsf","inner":"irO4CFfl9jmps6Q1Pxgqe","innerText":"_3YnRlW_TGFl_Eu-lgMzYaj","comp":"_2CkT37ibU_-7aWzhpDIYkN","withIcon":"_3L0Ku5tAA9UbdHTGdKAhG","isDisabled":"_3j5UCpnuSkGgXUHpTaUQER","double":"_1oK-JtAAxIJt384Jq9FiYT","withBg":"_1sg5mWIUy09DNsW60dKVYH","large":"elOknBFL9PuQFN_exBsBa","image":"qwjnglsd3j61O8MMGa-49"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Inputs/Selector.css
// module id = 908
// module chunks = 0